import { Component, ViewChild, Injector, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { AppComponentBase } from '@shared/common/app-component-base';
import { RegistrationDto, NoteEditDto, CreateOrEditReceivableDto, NoteDto, CreateOrUpdateEditionDto, UserEditDto, CreateOrUpdateUserInput, CreateOrEditRegistrationDto, RegistrationsServiceProxy, UpdateNotesDto } from '@shared/service-proxies/service-proxies';
import { SubscriptionSituationType, AppNoteEditDtoType, PaymentChargeStatus, StatusIntegracao } from '@shared/AppEnums';

import * as moment from 'moment';

@Component({
    selector: 'detailModal',
    templateUrl: './detail-modal.component.html'
})

export class DetailModalComponent extends AppComponentBase {

    subscriptionSituationType = SubscriptionSituationType;
    paymentChargeStatus = PaymentChargeStatus;
    statusIntegracao = StatusIntegracao;

    @ViewChild('detailModal') modal: ModalDirective;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;

    registration: RegistrationDto;
    numberOfInstallments: number = 0;
    user: UserEditDto = new UserEditDto();
    //receivable: CreateOrEditReceivableDto = new CreateOrEditReceivableDto();

    newNote: string = "";

    constructor(
        injector: Injector,
        private _updateNotesService: RegistrationsServiceProxy
    ) {
        super(injector);
    }

    close(): void {

        this.active = false;
        this.modal.hide();
    }

    onShown(): void {
        this.modal.show();
    }

    public show(registration: RegistrationDto, numberOfInstallments: number): void {

        this.active = true;
        this.registration = registration;
        this.numberOfInstallments = numberOfInstallments;
        this.modal.show();
    }

    //Notes
    addNote(): void {

        if (this.newNote) {

            let note = new NoteDto();
            note.description = this.newNote;

            this.newNote = "";
            this.registration.notes.push(note);

            var element = <HTMLInputElement>document.getElementById("btnSave");
            element.disabled = false;
        }
    }

    save(): void {

        let model = new UpdateNotesDto();
        model.id = this.registration.id;
        model.newNotes = [];

        this.registration.notes.forEach(x => {

            let note = new NoteEditDto();
            note.description = x.description;
            note.creationTime = moment();
            note.type = AppNoteEditDtoType.PaymentCharge;

            model.newNotes.push(note);
        })

        this._updateNotesService.updateNotes(model)
            .finally(() => { this.saving = false; })
            .subscribe(() => {
                this.notify.info(this.l('SavedSuccessfully'));
                this.close();
                this.modalSave.emit(null);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/event/registrations/modals/detail/detail-modal.component.ts